import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { show, changeAfiliado, updatePassword, success as changeSuccess } from '../../../store/actions/afiliados.action'
import { AppBar, Button, CircularProgress, IconButton, TextField, Toolbar, Typography } from '@material-ui/core'
import { MdKeyboardBackspace } from 'react-icons/md'
import { FaSave } from 'react-icons/fa'
import { changeScreen } from '../../../store/actions/navigation.action'


export default function Password(props) {
    const dispatch = useDispatch()
    const { afiliado, error, success } = useSelector(state => state.afiliadosReducer)
    const id = (props.uid) ? props.uid : null
    const [isLoading, setLoading] = React.useState(true)

    React.useEffect(() => {
        dispatch(show(id)).then(res => res && setLoading(false))

        return () => {
            dispatch(changeSuccess(false))
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div className="app-bar">
            <AppBar position="fixed">
                <Toolbar>
                    <IconButton onClick={() => dispatch(changeScreen({ open: false }))} edge="start" color="inherit">
                        <MdKeyboardBackspace />
                    </IconButton>
                    <Typography variant="h6">
                        Editar Senha
                    </Typography>

                    <Button 
                        variant="contained" 
                        size="small"
                        onClick={() => dispatch(updatePassword(afiliado)) }
                        color="inherit" 
                        className="ms-auto btn-app-bar"
                        startIcon={<FaSave />}
                    >
                        Salvar
                    </Button>
                </Toolbar>
            </AppBar>

            {(isLoading) ? <div className="d-flex justify-content-center m-5 p-5"> <CircularProgress /> </div> :
            
            <div className="card card-body mt-3 bs-bg">
                <div className="mb-3">
                    <label className="label-custom bs-color-b">Email</label>
                    <TextField
                        error={(error.email) && true}
                        value={afiliado.email || ''}
                        onChange={text => {
                            dispatch(changeAfiliado({ email: text.target.value }))
                            if (error.email && delete error.email);
                        }}
                    />

                    {(error.email) &&
                        <strong className="text-danger">{error.email[0]}</strong>
                    }
                </div>

                <div className="mb-3">
                    <label className="label-custom bs-color-b">Senha</label>
                    <TextField
                        error={(error.password) && true}
                        value={afiliado.password || ''}
                        type="password"
                        onChange={text => {
                            dispatch(changeAfiliado({ password: text.target.value }))
                            if (error.password && delete error.password);
                        }}
                    />

                    {(error.password) &&
                        <strong className="text-danger">{error.password[0]}</strong>
                    }
                </div>
            </div>
            }
        </div>
    )
}